import {
  scaleLinear,
} from 'd3-scale';
import {
  ILoadable,
  LoadableStatus,
} from '../../Utils';
import {
  IntervalWidener,
} from '../../viz/Utils';
import {
  getWidendedAndNicedDomain,
  IAggregateOutput,
  IAssignYOutput,
  IProcessedNodePrecursorWithCoords,
  ISize,
  YAxisMeasure,
} from './Utils';

const getAssign = (widenIntervalY: IntervalWidener) => (
    yAxisMeasure: YAxisMeasure,
    withoutYStatus: ILoadable<IAggregateOutput>,
    sizeStatus: ILoadable<ISize>,
  ): ILoadable<IAssignYOutput> => {

  let result: ILoadable<IAssignYOutput>;
  if (withoutYStatus.status === LoadableStatus.Initial ||
      sizeStatus.status === LoadableStatus.Initial) {
    result = {status: LoadableStatus.Initial};
  } else if (withoutYStatus.status === LoadableStatus.Loading ||
              sizeStatus.status === LoadableStatus.Loading) {
    result = {status: LoadableStatus.Loading};
  } else if (withoutYStatus.status === LoadableStatus.NotPresent ||
              sizeStatus.status === LoadableStatus.NotPresent) {
    result = {status: LoadableStatus.NotPresent};
  } else {
    const {
      data: {
        nodes: withoutY,
        maxComplexity, minComplexity,
        maxOpportunityGain, minOpportunityGain,
        xAxisMin, xAxisMax, xScale,
        averageComplexity, averageOpportunityGain,
      },
    } = withoutYStatus;
    const {data: {height}} = sizeStatus;

    let domainStart: number, domainEnd: number;
    const useComplexity = (yAxisMeasure === YAxisMeasure.Complexity);

    if (useComplexity) {
      domainStart = minComplexity;
      domainEnd = maxComplexity;
    } else {
      domainStart = minOpportunityGain;
      domainEnd = maxOpportunityGain;
    }

    const [yAxisMin, yAxisMax] = getWidendedAndNicedDomain(domainStart, domainEnd, widenIntervalY);

    const yScale = scaleLinear<number, number>()
                  .domain([yAxisMin, yAxisMax])
                  .range([height, 0]);

    const withCoords: IProcessedNodePrecursorWithCoords[] = withoutY.map(datum => {
      const yValue = useComplexity ? datum.pci : datum.opportunityGain;
      return {
        ...datum,
        y: yScale(yValue),
        yValue,
      };
    });

    result = {
      status: LoadableStatus.Present,
      data: {
        nodes: withCoords,
        xAxisMin, xAxisMax, xScale,
        yAxisMin, yAxisMax, yScale,
        yAverage: useComplexity ? averageComplexity : averageOpportunityGain,
      },
    };
  }
  return result;
};

export default getAssign;
